import { Badge, Group, HoverCard, Stack, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { AlertPrompt } from '@/types/vlm'
import {
  MAX_VISIBLE_ALERT_TAGS,
  SEVERITY_BADGE_COLOR,
  SEVERITY_ORDER
} from './vlmPipelineConfig'

type PipelineAlertTagsProps = {
  alertPrompts: AlertPrompt[]
}

const sortBySeverity = (prompts: AlertPrompt[]) =>
  [...prompts].sort(
    (a, b) =>
      SEVERITY_ORDER.indexOf(a.severity) - SEVERITY_ORDER.indexOf(b.severity)
  )

const AlertTagBadge = ({ prompt }: { prompt: AlertPrompt }) => (
  <Badge
    variant="dot"
    color={SEVERITY_BADGE_COLOR[prompt.severity]}
    size="md"
    tt="none"
  >
    {prompt.name}
  </Badge>
)

export const PipelineAlertTags = ({ alertPrompts }: PipelineAlertTagsProps) => {
  if (alertPrompts.length === 0) {
    return (
      <Text size="xs" c="dimmed">
        <FormattedMessage id="vlm.pipelines.alerts.empty" />
      </Text>
    )
  }

  const sorted = sortBySeverity(alertPrompts)
  const visible = sorted.slice(0, MAX_VISIBLE_ALERT_TAGS)
  const hidden = sorted.slice(MAX_VISIBLE_ALERT_TAGS)

  return (
    <Group gap={4} wrap="wrap">
      {visible.map((prompt) => (
        <AlertTagBadge key={prompt.alert_tag} prompt={prompt} />
      ))}

      {hidden.length > 0 && (
        <HoverCard shadow="md" position="top" openDelay={100} withArrow>
          <HoverCard.Target>
            <Badge variant="outline" color="gray" size="sm" tt="none">
              <FormattedMessage
                id="vlm.pipelines.alerts.more"
                values={{ count: hidden.length }}
              />
            </Badge>
          </HoverCard.Target>

          <HoverCard.Dropdown p="xs">
            <Stack gap={6}>
              {hidden.map((prompt) => (
                <AlertTagBadge key={prompt.alert_tag} prompt={prompt} />
              ))}
            </Stack>
          </HoverCard.Dropdown>
        </HoverCard>
      )}
    </Group>
  )
}
